import { createFileRoute } from '@tanstack/react-router'
import { ClientProfile } from '@/features/clients/client-profile'
import { requirePermission } from '@/lib/route-guards'

export const Route = createFileRoute('/_app/clients/$clientId')({
  beforeLoad: requirePermission('clients:read'),
  component: ClientDetailPage,
})

/** Ficha del cliente. */
function ClientDetailPage() {
  const { clientId } = Route.useParams()
  return <ClientProfile key={clientId} clientId={clientId} />
}
